import {format, isToday, isValid, isYesterday, parseISO} from 'date-fns';

export const formatNotificationDate = (value: string) => {
  const date = parseISO(value);

  if (!isValid(date)) {
    return value;
  }

  const time = format(date, 'H:mm');

  if (isToday(date)) {
    return `Сегодня ${time}`;
  }

  if (isYesterday(date)) {
    return `Вчера ${time}`;
  }

  return format(date, 'dd.MM.yyyy, H:mm');
};
